import React, { useState } from 'react';
import { Megaphone, Calendar, User, ExternalLink, Pin, Bell, AlertCircle, Info, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Badge } from '../components/ui/Badge';
import { useNavigate } from 'react-router-dom';
export function AnnouncementsPage() {
  const navigate = useNavigate();
  const [filter, setFilter] = useState<'all' | 'pinned' | 'unread'>('all');
  const announcements = [{
    id: 1,
    type: 'meeting',
    title: 'Undangan Rapat Komite Pusat Q1 2025',
    content: 'Kepada seluruh anggota komite pusat, kami mengundang Anda untuk menghadiri rapat evaluasi Q4 2024 dan perencanaan Q1 2025. Rapat akan membahas program kerja, anggaran, dan strategi pengembangan organisasi.',
    author: 'Komite Pusat ATIOS',
    date: '2025-01-10T10:00:00',
    isPinned: true,
    isRead: false,
    priority: 'high',
    eventId: 6,
    eventLink: '/meetings/6'
  }, {
    id: 2,
    type: 'announcement',
    title: 'Pembukaan Pendaftaran Member Baru 2025',
    content: 'ATIOS membuka pendaftaran member baru untuk tahun 2025! Dapatkan early bird discount 30% untuk pendaftaran sebelum 31 Januari 2025. Ajak rekan-rekan Anda untuk bergabung dan kembangkan ekosistem teknologi Indonesia bersama.',
    author: 'Tim Keanggotaan',
    date: '2025-01-08T14:00:00',
    isPinned: true,
    isRead: false,
    priority: 'high',
    eventId: null,
    eventLink: null
  }, {
    id: 3,
    type: 'event',
    title: 'Workshop Advanced React & Next.js - Kuota Terbatas!',
    content: 'Hanya tersisa 12 kursi untuk workshop Advanced React & Next.js yang akan diadakan tanggal 15-16 Januari 2025. Jangan lewatkan kesempatan belajar langsung dari expert! Daftar sekarang sebelum kehabisan.',
    author: 'Tim Event',
    date: '2025-01-07T09:00:00',
    isPinned: false,
    isRead: true,
    priority: 'medium',
    eventId: 1,
    eventLink: '/events/1'
  }, {
    id: 4,
    type: 'meeting',
    title: 'Rapat Koordinasi Chapter Jakarta - 22 Januari',
    content: 'Rapat koordinasi bulanan chapter Jakarta akan diadakan pada 22 Januari 2025 pukul 19:00 WIB. Agenda: evaluasi program Desember, perencanaan event Februari, dan pembahasan kerjasama dengan komunitas lain.',
    author: 'Chapter Jakarta',
    date: '2025-01-06T16:00:00',
    isPinned: false,
    isRead: true,
    priority: 'medium',
    eventId: 3,
    eventLink: '/events/3'
  }, {
    id: 5,
    type: 'announcement',
    title: 'Update Sistem Membership Portal',
    content: 'Kami telah melakukan update pada sistem membership portal. Fitur baru yang ditambahkan: notifikasi real-time, download sertifikat otomatis, dan integrasi dengan chapter management. Silakan logout dan login kembali untuk melihat perubahan.',
    author: 'Tim IT',
    date: '2025-01-05T11:00:00',
    isPinned: false,
    isRead: true,
    priority: 'low',
    eventId: null,
    eventLink: null
  }, {
    id: 6,
    type: 'announcement',
    title: 'Perpanjangan Masa Keanggotaan 2025',
    content: 'Bagi member yang masa keanggotaannya akan berakhir pada Q1 2025, silakan lakukan perpanjangan sebelum tanggal 31 Maret 2025. Dapatkan diskon 15% untuk perpanjangan early bird!',
    author: 'Tim Keanggotaan',
    date: '2025-01-04T13:00:00',
    isPinned: false,
    isRead: true,
    priority: 'medium',
    eventId: null,
    eventLink: null
  }, {
    id: 7,
    type: 'event',
    title: 'Webinar Gratis: AI & Machine Learning Trends 2025',
    content: 'Ikuti webinar gratis tentang tren AI dan Machine Learning di tahun 2025. Pembicara: Dr. Sarah Williams, AI Researcher. Tanggal: 20 Januari 2025, Pukul 14:00 WIB. Gratis untuk semua member!',
    author: 'Tim Event',
    date: '2025-01-03T10:00:00',
    isPinned: false,
    isRead: true,
    priority: 'low',
    eventId: 2,
    eventLink: '/events/2'
  }, {
    id: 8,
    type: 'announcement',
    title: 'Selamat Tahun Baru 2025!',
    content: 'Selamat Tahun Baru 2025 untuk seluruh member ATIOS! Mari kita sambut tahun baru dengan semangat kolaborasi yang lebih kuat dalam mengembangkan ekosistem teknologi informasi Indonesia. Terima kasih atas kontribusi Anda di tahun 2024!',
    author: 'Komite Pusat ATIOS',
    date: '2025-01-01T00:00:00',
    isPinned: false,
    isRead: true,
    priority: 'low',
    eventId: null,
    eventLink: null
  }];
  const filteredAnnouncements = announcements.filter(announcement => {
    if (filter === 'pinned') return announcement.isPinned;
    if (filter === 'unread') return !announcement.isRead;
    return true;
  });
  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'meeting':
        return Calendar;
      case 'event':
        return Bell;
      case 'announcement':
        return Megaphone;
      default:
        return Info;
    }
  };
  const getTypeColor = (type: string) => {
    switch (type) {
      case 'meeting':
        return 'text-warning';
      case 'event':
        return 'text-atios-primary';
      case 'announcement':
        return 'text-success';
      default:
        return 'text-neutral-600';
    }
  };
  const getPriorityBadge = (priority: string) => {
    switch (priority) {
      case 'high':
        return <Badge variant="error" data-id="element-1006">PENTING</Badge>;
      case 'medium':
        return <Badge variant="warning" data-id="element-1007">MEDIUM</Badge>;
      case 'low':
        return <Badge variant="default" data-id="element-1008">INFO</Badge>;
      default:
        return null;
    }
  };
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - date.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays === 0) return 'Hari ini';
    if (diffDays === 1) return 'Kemarin';
    if (diffDays < 7) return `${diffDays} hari yang lalu`;
    return date.toLocaleDateString('id-ID', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };
  const stats = [{
    label: 'Total Pengumuman',
    value: announcements.length.toString(),
    icon: Megaphone,
    color: 'bg-atios-light',
    iconColor: 'text-atios-primary'
  }, {
    label: 'Belum Dibaca',
    value: announcements.filter(a => !a.isRead).length.toString(),
    icon: AlertCircle,
    color: 'bg-warning-light',
    iconColor: 'text-warning'
  }, {
    label: 'Pengumuman Penting',
    value: announcements.filter(a => a.isPinned).length.toString(),
    icon: Pin,
    color: 'bg-error-light',
    iconColor: 'text-error'
  }];
  return <div className="min-h-screen bg-white" data-id="element-1009">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8" data-id="element-1010">
        {/* Header */}
        <div data-id="element-1011">
          <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-1012">
            Pengumuman
          </h1>
          <p className="text-neutral-600" data-id="element-1013">
            Informasi dan pengumuman terbaru dari ATIOS
          </p>
        </div>

        {/* Stats - FIXED: Proper contrast */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1014">
          {stats.map((stat, i) => <Card key={i} data-id="element-1015">
              <CardContent className="p-6" data-id="element-1016">
                <div className="flex items-center gap-4" data-id="element-1017">
                  <div className={`h-12 w-12 rounded-lg ${stat.color} flex items-center justify-center`} data-id="element-1018">
                    <stat.icon className={`h-6 w-6 ${stat.iconColor}`} data-id="element-1019" />
                  </div>
                  <div data-id="element-1020">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-1021">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-1022">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Filter */}
        <div className="flex gap-2" data-id="element-1023">
          <Button variant={filter === 'all' ? 'primary' : 'secondary'} onClick={() => setFilter('all')} data-id="element-1024">
            Semua
          </Button>
          <Button variant={filter === 'pinned' ? 'primary' : 'secondary'} onClick={() => setFilter('pinned')} data-id="element-1025">
            <Pin className="w-4 h-4 mr-2" data-id="element-1026" />
            Penting
          </Button>
          <Button variant={filter === 'unread' ? 'primary' : 'secondary'} onClick={() => setFilter('unread')} data-id="element-1027">
            <AlertCircle className="w-4 h-4 mr-2" data-id="element-1028" />
            Belum Dibaca
          </Button>
        </div>

        {/* Announcements List */}
        <div className="space-y-4" data-id="element-1029">
          {filteredAnnouncements.map(announcement => {
          const TypeIcon = getTypeIcon(announcement.type);
          const typeColor = getTypeColor(announcement.type);
          return <Card key={announcement.id} className={`${!announcement.isRead ? 'border-atios-primary border-2' : ''}`} data-id="element-1030">
                <CardHeader data-id="element-1031">
                  <div className="flex items-start justify-between gap-4" data-id="element-1032">
                    <div className="flex items-start gap-4 flex-1" data-id="element-1033">
                      <div className={`h-10 w-10 rounded-lg bg-neutral-100 flex items-center justify-center flex-shrink-0`} data-id="element-1034">
                        <TypeIcon className={`h-5 w-5 ${typeColor}`} data-id="element-1035" />
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-1036">
                        <div className="flex items-center gap-2 mb-2" data-id="element-1037">
                          {announcement.isPinned && <Pin className="w-4 h-4 text-error flex-shrink-0" data-id="element-1038" />}
                          {!announcement.isRead && <div className="h-2 w-2 rounded-full bg-atios-primary flex-shrink-0" data-id="element-1039" />}
                          <CardTitle className="text-base text-neutral-900" data-id="element-1040">
                            {announcement.title}
                          </CardTitle>
                        </div>
                        <div className="flex items-center gap-2 text-xs text-neutral-600 mb-3" data-id="element-1041">
                          <User className="w-3 h-3" data-id="element-1042" />
                          <span data-id="element-1043">{announcement.author}</span>
                          <span data-id="element-1044">•</span>
                          <span data-id="element-1045">{formatDate(announcement.date)}</span>
                        </div>
                      </div>
                    </div>
                    {getPriorityBadge(announcement.priority)}
                  </div>
                </CardHeader>
                <CardContent className="space-y-4" data-id="element-1046">
                  <p className="text-sm text-neutral-700 leading-relaxed" data-id="element-1047">
                    {announcement.content}
                  </p>

                  {announcement.eventLink && <div className="flex gap-2" data-id="element-1048">
                      <Button variant="primary" size="sm" onClick={() => navigate(announcement.eventLink!)} data-id="element-1049">
                        {announcement.type === 'meeting' ? 'Lihat Detail Rapat' : 'Lihat Event'}
                        <ExternalLink className="w-3.5 h-3.5 ml-2" data-id="element-1050" />
                      </Button>
                    </div>}

                  {!announcement.isRead && <Button variant="ghost" size="sm" className="text-atios-primary hover:text-atios-secondary" data-id="element-1051">
                      <CheckCircle className="w-4 h-4 mr-2" data-id="element-1052" />
                      Tandai Sudah Dibaca
                    </Button>}
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </div>;
}